import React from "react";
import { Box } from "@mui/material";

import FacilitiesTableFilter from "../FacilitiesTableFilter";
import useStyles from "./styles";

const FacilitiesHeader = ({ onAddData, countryList, onApplyFilter }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <FacilitiesTableFilter
        countryList={countryList}
        onAddData={onAddData}
        onApplyFilter={onApplyFilter}
      />
    </Box>
  );
};

export default FacilitiesHeader;
